export enum SalesStatusEnum {
  COMMING_SOON = 'COMMING_SOON',
  SALES_OPENED = 'SALES_OPENED',
  SALES_CLOSED = 'SALES_CLOSED',
  SOLD_OUT = 'SOLD_OUT'
}
